import * as React from 'react';
import { observer } from 'mobx-react';
import { SelectableCard } from '../../atoms/select/SelectableCard';
import './selectableLocationCard.module.scss';
import { SheLocation } from '../../../types/location';
import { DirectionsTransit, LaunchOutlined, RoomOutlined } from '@material-ui/icons';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

const LocationSummary = observer(({ location }) => {
  if (!location) {
    return (
      <div styleName="location-summary">
        <div styleName="title">オンライン</div>
        <div styleName="description">
          関東圏以外からのご利用など、基本的にオンライン利用のみの方はこちらをお選びください
        </div>
      </div>
    );
  }
  const GoogleMapLink = ({ className = undefined }) => (
    <a styleName="link" className={className} href={location.google_map_url} target="_blank">
      Google Mapで見る
      <LaunchOutlined styleName="link-icon" />
    </a>
  );
  const sp = GlobalStatesV3.viewport.isSp;
  return (
    <div styleName="location-summary">
      <div styleName="title">{location.name}</div>
      <div styleName="address">
        <RoomOutlined styleName="icon" />
        <span>
          〒{location.zipcode} {location.address}
        </span>
        {location.google_map_url && !sp && <GoogleMapLink />}
      </div>
      {location.access_summary && (
        <div styleName="access-summary">
          <DirectionsTransit styleName="icon" />
          {location.access_summary}
        </div>
      )}
      {sp && <GoogleMapLink styleName={'bottom'} />}
    </div>
  );
});

type Props = {
  id?: string;
  current: boolean;
  selected: boolean;
  location: SheLocation;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: () => any;
};
export const SelectableLocationCard = ({ id, current, selected, location, onClick }: Props) => {
  return (
    <SelectableCard
      id={id}
      current={current}
      currentLabel={'選択中'}
      selected={selected}
      footer={null}
      onClick={onClick}
    >
      <LocationSummary location={location} />
    </SelectableCard>
  );
};
